/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MarkInTransitResult
 */
export interface MarkInTransitResult {
  /**
   *
   * @type {boolean}
   * @memberof MarkInTransitResult
   */
  trackingLinePublished: boolean;
}

/**
 * Check if a given object implements the MarkInTransitResult interface.
 */
export function instanceOfMarkInTransitResult(
  value: object,
): value is MarkInTransitResult {
  if (
    !("trackingLinePublished" in value) ||
    value["trackingLinePublished"] === undefined
  )
    return false;
  return true;
}

export function MarkInTransitResultFromJSON(json: any): MarkInTransitResult {
  return MarkInTransitResultFromJSONTyped(json, false);
}

export function MarkInTransitResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MarkInTransitResult {
  if (json == null) {
    return json;
  }
  return {
    trackingLinePublished: json["trackingLinePublished"],
  };
}

export function MarkInTransitResultToJSON(json: any): MarkInTransitResult {
  return MarkInTransitResultToJSONTyped(json, false);
}

export function MarkInTransitResultToJSONTyped(
  value?: MarkInTransitResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    trackingLinePublished: value["trackingLinePublished"],
  };
}
